<template>
    <div id="app">
        <el-container>
            <el-header>
                <div class="logo">
                    <img v-show="false" src="./assets/img/toplogo.png" alt/>
                </div>
                <el-menu
                        :default-active="defaultActive"
                        class="el-menu-demo"
                        mode="horizontal"
                        @select="handleSelect"
                        :router="router">
                    <el-menu-item index="/">首页</el-menu-item>
                    <el-menu-item index="/product">核心理念</el-menu-item>
                    <el-menu-item index="/news">核心产品</el-menu-item>
                </el-menu>
            </el-header>
            <el-main id="v-content" v-bind:style="{minHeight: Height+'px',background:'#1D2643'}">
                <router-view/>
            </el-main>
            <div class="footer">
                <div class="copyright">
                    <div class="horizontal">
                        <a target="top" style="display:none;"
                           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602010583">
                            <div class="horizontal">
                                <img src="./assets/img/jingbeihao.png"/>
                                <p style="color: #999999;">粤公网安备 44010602010583号</p>
                            </div>
                        </a>
                        <a href="https://beian.miit.gov.cn/" target="top"
                           style="color: #999999;margin-left: 40px;line-height: 40px">备案号:粤ICP备2025450518号-1</a>
                        <span>汉光企业信息咨询(惠州市)有限公司版权所有</span>
                    </div>


                </div>
            </div>
        </el-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                router: true,
                defaultActive: "/",
                isShow: false,
                Height: 0
            };
        },
        methods: {


            handleSelect(key) {
                this.isShow = this.defaultActive != key;
                window.console.log(this.isShow);
            }
        },
        mounted(){
            //动态设置内容高度 让footer始终居底   header+footer的高度是100
            this.Height = document.documentElement.clientHeight - 100;
            //监听浏览器窗口变化　
            window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
        }
    };
</script>

<style lang="scss">
    * {
        padding: 0;
        margin: 0;
    }

    html,
    body {
        height: 100%;
    }

    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    .el-header {
        display: flex;
        justify-content: space-between;
        align-content: center;
        width: 1240px;
        margin: 0 auto;
        //background-color: #fff;

        .logo {
            width: 280px;
            padding: 10px;

            img {
                width: 100%;
                line-height: 60px;
            }
        }
    }

    .el-main {
        padding: 0 !important;
    }

    .footer {
        width: 100%;
        //height: 246px;//246px
        overflow: hidden;
        background-color: #14679f;

        &-content {
            width: 1240px;
            margin: 0 auto;
            padding-top: 20px;
            display: flex;
            justify-content: space-between;

            .content-nav {
                display: flex;
                justify-content: space-around;

                li {
                    display: flex;
                    flex-direction: column;
                    padding: 0 20px;
                    //justify-content: center;
                    align-items: flex-start;

                    p {
                        font-size: 20px;
                        color: #d4edff;
                        padding: 10px 0;
                    }

                    span {
                        color: #f7f7f7;
                        font-weight: 300;
                        padding: 5px 0;
                    }
                }
            }

            img {
                width: 170px;
                height: 170px;
                padding: 10px;
            }
        }

        .copyright {
            background: #1D2643;
            line-height: 40px;
            height: 40px;
            text-align: center;

            .horizontal {
                display: -webkit-flex; /* Safari */
                display: flex;
                flex-direction: row;
                justify-content: center;

            }

            a {
                text-decoration: none;
            }

            img {
                width: 20px;
                height: 20px;
                margin-top: 10px;
            }

            span {
                color: #999999;
                margin-left: 40px;
            }
        }
    }
</style>
